<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>岗位管理</h1>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn color="primary" @click="showCreateJobDialog()"
          >Create New Job
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="jobs"
      :items-per-page="5"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small @click="showEditJobDialog(item)">mdi-pencil</v-btn>
        <v-btn small @click="showDeleteJobConfirm(item)">mdi-delete</v-btn>
      </template>
    </v-data-table>

    <create-job-popup ref="createJobPopup" />
    <edit-job-popup
      ref="editJobPopup"
      :item="selectedJob"
      @update-job="updateJob"
    ></edit-job-popup>
    <delete-job-confirmation
      ref="deleteJobConfirmation"
      :item="selectedJob"
    ></delete-job-confirmation>
  </v-container>
</template>

<script>
import CreateJobPopup from "../components/CreateJobPopup.vue";
import EditJobPopup from "../components/EditJobPopup.vue";
import DeleteJobConfirmation from "../components/DeleteJobConfirmation.vue";

export default {
  components: {
    CreateJobPopup,
    EditJobPopup,
    DeleteJobConfirmation,
  },
  data() {
    return {
      newJob: {
        company: "",
        type: "",
        source: "",
        name: "",
        requirements: "",
        location: "",
        target: "",
        link: "",
        startDate: "",
        endDate: "",
        remarks: "",
      },
      jobs: [
        // 这里可以添加一些模拟数据
        {
          company: "即刻上岸",
          type: "实习",
          source: "网申",
          name: "设计人员",
          requirements: "设计相关科",
          location: "北京",
          target: "2024在校生",
          link: "www.jikeoffer.top",
          startDate: "2020-01-01",
          endDate: "2020-11-11",
          remarks: "无",
        },
      ],
      headers: [
        { text: "公司名称", value: "company" },
        { text: "招聘类型", value: "type" },
        { text: "招聘渠道", value: "source" },
        { text: "岗位名称", value: "name" },
        { text: "工作地点", value: "location" },
        { text: "招聘对象", value: "target" },
        { text: "投递链接", value: "link" },
        { text: "修改时间", value: "modified" },
        { text: "操作", value: "actions", sortable: false },
      ],
      selectedJob: {},
    };
  },
  methods: {
    showCreateJobDialog() {
      this.$refs.createJobPopup.dialog = true;
      console.log("showCreateJobDialog");
    },
    showEditJobDialog(item) {
      this.selectedJob = { ...item };
      this.$refs.editJobPopup.dialog = true;
    },
    showDeleteJobConfirm(item) {
      this.selectedJob = { ...item };
    },
    addJob(job) {
      this.jobs.push({ ...job, modified: new Date().toLocaleString() });
      this.$refs.createJobPopup.dialog = true;
    },
    updateJob(item) {
      console.log("Edit item:", item);
    },
    deleteItem(item) {
      console.log("Delete item:", item);
    },
  },
};
</script>